import { memo, useCallback, useEffect } from "react";

const TOLERANCE_OPTIONS = [
    { id: false, label: 'Tolérant' },
    { id: true, label: 'Strict' },
];

const HINTS = {
    false: 'Ignore les majuscules, accents et espaces superflus.',
    true: "L'élève doit taper exactement cette réponse.",
};

function TexteLibreResponseEditor({ answer, onAnswerChange, strict, onStrictChange, suffixe = '', onSuffixeChange, onValidChange }) {
    const isValid = answer.trim().length > 0;

    useEffect(() => {
        onValidChange(isValid);
    }, [isValid, onValidChange]);

    const handleAnswerChange = useCallback((e) => {
        onAnswerChange(e.target.value);
    }, [onAnswerChange]);

    return (
        <div className="p-3 sm:p-5 rounded-2xl border border-gray-200 bg-white shadow-sm">
            <h3 className="text-xs sm:text-sm font-semibold text-gray-600 uppercase tracking-wide flex items-center gap-2 mb-3">
                <span className="w-5 h-5 rounded bg-sky-100 text-sky-800 text-[10px] font-extrabold flex items-center justify-center">2</span>
                Réponse attendue
            </h3>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-2.5 sm:items-stretch">
                <input
                    type="text"
                    value={answer}
                    onChange={handleAnswerChange}
                    placeholder="Saisir la réponse correcte..."
                    className="flex-1 px-3 py-2.5 border-2 border-emerald-500 rounded-lg text-sm font-medium bg-emerald-50/50 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-200"
                />
                <div className="flex rounded-full overflow-hidden border border-gray-200 self-center">
                    {TOLERANCE_OPTIONS.map(({ id, label }) => (
                        <button
                            key={String(id)}
                            type="button"
                            onClick={() => onStrictChange(id)}
                            className={`px-3.5 py-2 text-[11px] font-medium transition-all ${
                                strict === id
                                    ? 'bg-blue-900 text-white'
                                    : 'text-gray-500 hover:bg-gray-50'
                            }`}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Suffixe d'unité — optionnel */}
            {onSuffixeChange && (
                <div className="flex items-center gap-2 mt-3">
                    <label className="text-[11px] text-gray-500 font-medium whitespace-nowrap">Unité :</label>
                    <input
                        type="text"
                        value={suffixe}
                        onChange={(e) => onSuffixeChange(e.target.value)}
                        placeholder="cm, kg, €..."
                        className="w-28 px-2.5 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-700 placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-300"
                    />
                    <span className="text-[10px] text-gray-400">Affiché après le champ de saisie</span>
                </div>
            )}

            <p className="text-[11px] text-gray-400 mt-2">
                {HINTS[String(strict)]}
            </p>
        </div>
    );
}

export default memo(TexteLibreResponseEditor);
